import { AxiosError } from 'axios'

import { insertToast } from '~/modules/toasts/services'
import { api } from '~/utils/api'

import { DashboardData } from './types'

export async function getDashboardData(): Promise<DashboardData | null> {
  return api
    .get<DashboardData>('/admin/dashboard')
    .then(({ data }) => data)
    .catch((error: AxiosError<APIError>) => {
      if (error.response?.data.message) {
        insertToast({
          duration: 3,
          message: error.response?.data.message,
          title: 'Erro ao tentar criar personal trainer',
        })
      }
      return null
    })
}
